module.exports = __webpack_public_path__ + "static/bcc-e6577a78e2ca452c5a18a077f5ac8f45.mp4";